import styled from '@emotion/styled';

import {
  black,
  blueBlack400,
  blueBlack630,
  blueBlack650,
  blueUltramarine200,
  blueUltramarine500,
  green300,
  greyLight300,
  greyLight400,
  greyLight600,
  orange700,
  red400,
  white,
} from '../../theme/videa-style-tokens';

export const OnboardingContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  padding: 0;
  box-sizing: border-box;
  background-color: ${greyLight400};
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1000;

  .inner-onboard-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: ${white};
    box-sizing: border-box;
    justify-content: space-between;
    height: 100%;
    width: 100%;
    overflow: hidden;
    position: relative;
    box-sizing: border-box;
    gap: 1em;
    z-index: 10;
    border-radius: 0.5em;

    .template {
      height: 100%;
      width: 100%;
      padding: 3em;
      overflow-y: auto;
      overflow-x: visible;
      box-sizing: border-box;
    }

    @media (max-width: 1300px) {
      display: block;
      position: relative;
      padding: 0;

      .template {
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
      }
    }
  }

  .MuiSvgIcon-colorWarning {
    color: ${orange700};
  }

  .title-default {
    color: ${blueBlack650};
    svg {
      fill: ${blueBlack650};
    }
  }
  .title-success {
    color: ${green300};
    svg {
      fill: ${green300};
    }
  }
  .title-error {
    color: ${red400};
    svg {
      fill: ${red400};
    }
  }
  .title-warning {
    color: ${orange700};
    svg {
      fill: ${orange700};
    }
  }

  .paragraph {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .paragraph-header {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      flex-wrap: nowrap;
      color: ${blueBlack650};
      font-size: 1.125em;
      gap: 0.25em;
      padding: 1em 0 0.5em;

      .title {
        font-family: 'Neue Haas Grotesk Display Pro';
        font-weight: 600;
        line-height: 1.25em;
      }

      .icon-header {
        transform: translateY(-0.125em);
      }
    }

    .paragraph-body {
      font-family: 'Neue Haas Grotesk Display Pro';
      font-style: normal;
      font-weight: 400;
      font-size: 1.25em;
      line-height: 1.3em;
      color: ${black};
      white-space: pre-line;
      &.content-small {
        font-size: 1em;
      }
      &.content-large {
        font-size: 1.5em;
      }
      &.content-bold {
        font-weight: 600;
        font-size: 1em;
      }
    }
  }

  .section {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 1em;

    &.section-text {
      width: 18em;
      padding-right: 1em;
    }

    &.section-images {
      width: 19em;

      .image-caption {
        max-width: 20em;

        .caption-title {
          font-weight: 600;
          display: inline-block;
          margin-bottom: 0.25em;
          color: ${blueBlack630};
        }
      }
    }

    &.section-mix {
      width: fit-content;
    }

    .section-header {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      flex-wrap: nowrap;
      height: 3.75em;
      color: ${blueBlack650};
      font-size: 1.5em;
      padding-top: 1.5em;

      .title {
        font-family: 'Neue Haas Grotesk Display Pro';
        font-weight: 600;
        font-size: 1.25em;
        line-height: 1em;
      }

      &.section-header-icon {
        align-items: center;
        justify-content: flex-start;
        padding-right: 1em;
        gap: 0.375em;

        .icon-header {
          font-size: 2em;
        }

        .title {
          font-size: 0.75em;
          font-weight: 600;
        }
      }
    }

    .paragraphs {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      height: 100%;
      width: fit-content;
      gap: 1em;
    }

    .images {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      flex-wrap: nowrap;
      height: 100%;
      width: fit-content;
      gap: 1em;

      .content-image {
        &.image-full {
          width: 100%;
          max-width: 100%;
          margin-right: 1em;
        }
        &.image-inline {
          width: auto;
        }
      }

      .image-caption {
        font-family: 'Neue Haas Grotesk Display Pro';
        font-weight: 500;
        font-size: 1em;
        line-height: 1.1em;
        color: ${black};
        white-space: pre-line;
        padding: 1.5em 1em 0 0;
      }
    }
  }

  .template-intro {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: nowrap;
    height: 100%;
    gap: 2em;

    .title-header {
      display: inline-block;
      line-height: 1em;
      box-sizing: border-box;
      width: 18em;
      height: 100%;
      padding: 2em 1.5em 0 3em;

      .title {
        line-height: 1em;
        display: inline-block;
        width: 100%;
      }
    }
    .sections {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: flex-start;
      height: fit-content;
      width: fit-content;
      max-width: 100%;
      gap: 1.5em;
      padding-bottom: 4em;
    }
  }

  .template-default {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    box-sizing: border-box;

    .title-header {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      flex-wrap: nowrap;
      height: 4em;
      width: 100%;
      gap: 2em;
      padding: 0 2em 0 3em;
      line-height: 1em;

      .title {
        width: 10em;
        line-height: 1em;
      }

      .subtitle {
        font-family: 'Neue Haas Grotesk Display Pro';
        font-weight: 600;
        font-size: 1.75em;
        width: 14em;
        line-height: 1.1em;
      }
    }
    .sections {
      box-sizing: border-box;
      padding-left: 3em;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: flex-start;
      height: 100%;
      max-width: 100%;
      width: fit-content;

      .content-image {
        .image-element {
          max-width: 15em;
        }
        .image-caption {
          padding-right: 1em;
        }
      }
    }
  }

  .template-embed.template-default {
    .sections {
      flex-direction: row;
      gap: 2em;

      .section-embed {
        .section-header {
          display: none;
        }
        background-color: ${greyLight400};
        border-radius: 2em;
        padding: 2em;
        margin-top: 5em;
        width: fit-content;
        max-width: 44em;
      }
    }

    @media (max-width: 1300px) {
      .sections {
        flex-direction: column;
        gap: 1em;

        .section-embed {
          margin-top: 0;
          align-self: center;
        }

        .section-text {
          .section-header {
            margin: 0;
            padding: 0;
          }
        }
      }
    }
  }

  .button {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 6em;
    gap: 0.5em;
    font-family: 'Neue Haas Grotesk Display Pro';
    font-weight: 400;
    font-size: 1em;
    line-height: 3em;
    font-weight: 600;
    color: ${blueBlack650};
  }

  .title-header {
    width: 22.5em;

    .title {
      display: inline-block;
      font-family: 'Neue Haas Grotesk Display Pro';
      font-weight: 400;
      font-size: 2em;
      color: ${blueBlack400};
    }
  }

  @media (max-width: 1300px) {
    .inner-onboard-container {
      justify-content: flex-start;
    }
    .template-intro,
    .template-default {
      flex-direction: column;
      align-items: center;
      gap: 2em;
      width: 100%;

      .sections {
        width: 100%;
        flex-direction: column;
        gap: 3em;
        box-sizing: border-box;
        padding: 1rem 3rem 8em 0;

        .section {
          padding: 0 3rem 0 5rem;
          width: 100%;
          box-sizing: border-box;

          .images {
            width: 100%;

            .image-element {
              max-width: 100%;
            }
          }

          .section-header {
            height: fit-content;
            padding: 0 0 1em 0;

            .title {
              width: 100%;
              font-size: 1em;
            }
          }

          &.section-text {
            width: 100%;
          }

          &.section-images {
            width: 100%;
          }

          &.section-mix {
            width: 100%;
          }
          &:last-child {
            padding-bottom: 5em;
          }
        }
      }

      .title-header {
        width: 100%;
        padding: 3em 4rem 0 5rem;
        height: fit-content;
      }
    }

    .template-default {
      .title-header {
        flex-direction: column;
        padding: 0 0 0 5rem;
        gap: 1em;

        .title,
        .subtitle {
          width: 100%;
          font-size: 1.5em;
          line-height: 1.1em;
        }
      }
      .sections {
        .section {
          padding: 0 3rem 0 3rem;

          .section-header,
          .section-header-icon {
            .title {
              font-size: 0.875em;
            }
            .icon-header {
              font-size: 1.5em;
            }
          }
          .content-image {
            display: flex;
            flex-direction: row;
            gap: 2em;
            width: 100%;
          }
        }
      }
    }
  }
`;

export const OnboardingHeader = styled.div`
  justify-content: space-between;
  align-items: flex-start;
  box-sizing: border-box;
  display: flex;
  padding: 1em;
  width: 100%;
  position: absolute;
  box-sizing: border-box;

  .close-button {
    background-color: ${greyLight300};
    height: 1.5em;
    width: 1.5em;
    border-radius: 0.25em;
    position: relative;
    z-index: 10;

    &:hover {
      background-color: ${greyLight600};
    }
  }

  svg.videa-logo {
    height: 2em;
    padding: 0 1em 0 0;
    position: relative;
    zx-index: 1;
  }

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 1.5em;
    right: 1em;
    width: 8em;
    height: 2.75em;
    border-radius: 0.5em;
    z-index: 0;
    background-color: ${white};
    opacity: 0.75;
  }

  @media (max-width: 1300px) {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1;

    svg.videa-logo {
      height: 3em;
      padding: 0.5em;
      z-index: 1;
      position: relative;
    }
  }
`;

export const OnboardingFooter = styled.div`
  align-items: center;
  background-color: rgba(255, 255, 255, 0.75);
  bottom: 0;
  box-sizing: border-box;
  display: flex;
  font-weight: 600;
  height: 4em;
  justify-content: space-between;
  left: 0;
  padding: 0.5em 2em;
  position: absolute;
  width: 100%;
  border-top: 1px solid ${greyLight300};

  .MuiButton-textPrimary {
    color: ${blueBlack630};
    font-family: 'Neue Haas Grotesk Display Pro', sans-serif;
    gap: 0.5em;
    font-weight: 500;
  }

  .button-prev {
    margin: 0 1em 0 0;

    &[disabled] {
      opacity: 0;
    }
  }
  .button-next {
    margin: 0 0 0 1em;
  }
  .button-start,
  .button-app {
    font-size: 1.25em;
    font-family: 'Neue Haas Grotesk Display Pro', sans-serif;
    color: ${white};
  }
`;

export const OnboardingStart = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 2em 16em;
  height: 100%;
  box-sizing: border-box;

  .intro {
    .videa-logo {
      width: 300px;
      height: 100px;
    }

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    font-size: 1.625em;
    font-weight: 400;
    line-height: 1.3em;
    font-family: 'Neue Haas Grotesk Display Pro';
  }

  @media (max-width: 960px) {
    padding: 5em 10em 5em 5em;
    .intro {
      font-size: 1.25em;

      .videa-logo {
        width: 200px;
        height: 70px;
      }
    }
  }

  @media (max-width: 640px) {
    .videa-logo {
      display: none;
    }
  }
`;

export const OnboardingEnd = styled.div`
  box-sizing: border-box;
  height: 100%;
  background-image: url('/assets/images/onboarding/congrats.svg');
  background-position: -10em center;
  background-size: 60em;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 10em 16em 10em 40%;

  .MuiSvgIcon-root {
    fill: ${orange700};
    width: 1.5em;
    height: 1.5em;
    display: block;
    margin-bottom: 1em;
  }

  .outro {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    font-size: 1em;
    width: 18em;
    height: 100%;
    font-weight: 500;
    line-height: 1.3em;
    font-family: 'Neue Haas Grotesk Display Pro';
    color: ${blueBlack650};

    .inline-href {
      text-decoration: none;
      color: ${blueUltramarine500};
      font-weight: 500;
      display: inline;
    }
  }

  @media (max-width: 960px) {
    min-width: 30em;
    height: 100%;
    background-size: 60em;
    background-position: -5em top;
    padding: 20em 0 4em 0;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
  }

  @media (max-width: 640px) {
    padding: 20em 0 4em 0;
    overflow-y: auto;
    overflow-x: hidden;
  }
`;

export const Progress = styled.div`
  color: ${blueBlack630};
  display: flex;
  align-items: center;
  gap: 0.5em;
  .thermometer {
    width: 12em;
    height: 1.25em;
    border-radius: 0.625em;
    background-color: ${blueUltramarine200};
    .thermometer-value {
      height: 100%;
      border-radius: 0.625em 0 0 0.625em;
      background-color: ${green300};
    }
  }
`;

export const OnboardingContent = styled.div``;
